import React from 'react'

import styles from './styles.module.scss'

const StatsTile = ({ hideViewMore, label, value, color, className, link, icon, small, mini, style }) => {

  let classes = styles.statTile
  if (small || mini) {
    classes = styles.smallTile 
    if (mini) classes = `${classes} ${styles.miniTile}` 
  }
  
   
  if (color === 'red') classes = `${classes} ${styles.statTile__red}`
  if (color === 'blue') classes = `${classes} ${styles.statTile__blue}`
  if (color === 'orange') classes = `${classes} ${styles.statTile__orange}`
  if (color === 'teal') classes = `${classes} ${styles.statTile__teal}`
  if (color === 'navy') classes = `${classes} ${styles.statTile__navy}`
  if (color === 'grey') classes = `${classes} ${styles.statTile__grey}`  
  if (color === 'white') classes = `${classes} ${styles.statTile__white}`  
  if (className) classes = `${classes} ${className}`

  if (mini) {
    return (
      <div className={classes} style={style || null}>
        <div className={styles.smallTile_header}>
          {icon} {label}
        </div>
        <div className={styles.smallTile_content}>
          {value}
        </div>
      </div>
    )
  }

  if (small){
    return (
      <div className={classes} style={style || null}>
        <div className={styles.smallTile_header}>
          {icon} {label}
        </div>
        <div className={styles.smallTile_content}>
          {value}
        </div>
      </div>
    )
  }

  return (
    <div className={classes} style={style || null}>
      <div className={styles.statTile_header}>
        {icon} {label}
      </div>
      <div className={styles.statTile_content}>
        {value}
      </div>
      {!hideViewMore && (
        <div className={styles.statTile_footer}>
          {<p>View More <i className="fa-solid fa-angle-right"></i></p>}
        </div>
      )}
    </div>
  )
}

export default StatsTile